module.exports = __webpack_public_path__ + "img/wavesthumb.53042ec3.jpg";